import { SvgFactory } from '../../Svg';

const PlayIcon = SvgFactory(
    <svg xmlns='http://www.w3.org/2000/svg' width='48' height='48' viewBox='0 0 48 48' fill='black'>
        <path d='M13.8555 13.64V34.36C13.8555 35.94 15.5955 36.9 16.9355 36.04L33.2155 25.68C34.4555 24.9 34.4555 23.1 33.2155 22.3L16.9355 11.96C15.5955 11.1 13.8555 12.06 13.8555 13.64Z' />
    </svg>,
);

export default PlayIcon;
